// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__25Yfb","card":"styles_card__2vu8t","header":"styles_header__1RrSr"};